import { REDS } from '../constants/game';

export const fmt = (n) => '₹' + n.toLocaleString('en-IN');
export const short = (n) => (n >= 1000 ? (n / 1000).toFixed(1).replace('.0', '') + 'k' : String(n));
export const colorOf = (n) => (n === 0 || n === '00' ? 'green' : REDS.has(+n) ? 'red' : 'black');
export const cap = (s) => s[0].toUpperCase() + s.slice(1);
export const rnd = (n) => {
  const a = new Uint32Array(1);
  crypto.getRandomValues(a);
  return a[0] % n;
};
export const totalOf = (bets) => Object.values(bets).reduce((a, b) => a + b, 0);
export const chipClassFor = (amt) => (amt >= 500 ? 'c500' : amt >= 100 ? 'c100' : amt >= 10 ? 'c10' : 'c1');

const ALL = Array.from({ length: 36 }, (_, i) => i + 1);

// bet key -> kaun kaun se numbers cover hote hain
export function covered(key) {
  if (key.startsWith('n:')) return [key.slice(2)];
  let f;
  if (key.startsWith('col:')) {
    const c = +key.slice(4) % 3;
    f = (n) => n % 3 === c;
  } else if (key.startsWith('doz:')) {
    const d = +key.slice(4);
    f = (n) => n > 12 * (d - 1) && n <= 12 * d;
  } else {
    f = {
      low: (n) => n <= 18, high: (n) => n >= 19,
      even: (n) => n % 2 === 0, odd: (n) => n % 2 === 1,
      red: (n) => REDS.has(n), black: (n) => !REDS.has(n),
    }[key];
  }
  return ALL.filter(f).map(String);
}

export const mult = (key) => (key.startsWith('n:') ? 35 : /^(col|doz):/.test(key) ? 2 : 1);
